import React from 'react'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import InvoiceListing from './InvoiceListing'

export default function PayoutReceipts() {
  return (
    <>
      <SupportHeader heading="Payout Receipts" />
      <InvoiceListing 
        targetEntityType="mentor"
        title="Mentor Payout Receipts"
        initialFilters={{
          targetEntityTypes: 'mentor '
        }}
      />
    </>
  )
}
